module.exports = __webpack_public_path__ + "static/cauldron-dark-261794bc81ad7370b6d96c27988bb752.png";